<template>
    <div class="mkt">
        <div class="top-box">
            <el-button class="router-back" size="small" type="primary" @click="goBack()">
                返回
            </el-button>
            <div class="input-box">
                <el-input
                    v-model="result.title"
                    placeholder="请输入长图文标题"
                    maxlength="20"
                ></el-input>
            </div>
        </div>
        <div class="content">
            <div class="editor-wrap">
                <div class="tooltip">
                    注意事项： 使用H1、H2、H3标签时， 必须选择对应字号！
                </div>
                <wang-editor-custom
                    editorKey="shortStoryText"
                    :editorData="result.content"
                    :editorDisabled="false"
                    :editorConfig="{
                        placeholder: '请输入',
                        zIndex: '9',
                    }"
                    ref="customEditer"
                ></wang-editor-custom>
            </div>
            <div class="form-box">
                <sc-form-v2
                    name=""
                    tablename="CRM_TAG_GROUP"
                    :columnsNum="1"
                    :columns="columns"
                    :result.sync="result"
                    direction="vertical"
                    :esayStyle="true"
                    :columnsPaddingRight="20"
                    @change="changeFn"
                    @click="clickFn"
                    ref="groupform"
                >
                    <template v-slot:files>
                        <el-descriptions-item span="2" :labelStyle="{ background: '#fff' }">
                            <template slot="label">
                                <div class="labelName">封面</div>
                            </template>
                            <div class="upload-box">
                                <Upload
                                    ref="uploadbox"
                                    :limitNum="1"
                                    :width="90"
                                    :height="90"
                                    :accept="['jpg', 'gif', 'jpeg', 'png']"
                                    :showImgList="files"
                                    @uploadImgList="uploadImgList"
                                ></Upload>
                                <!-- <Upload
                                    ref="uploadbox"
                                    :showImgList="files"
                                    :limitNum="1"
                                    :width="90"
                                    :height="90"
                                    :accept="accept"
                                    :fileType="'video'"
                                    :ossClientCur="ossClient"
                                    @edit="editCover"
                                    :showPercen="true"
                                ></Upload> -->
                            </div>
                        </el-descriptions-item>
                    </template>
                </sc-form-v2>
                <div style="text-align: right; margin:100px 30px 20px 0">
                    <el-button
                        size="small"
                        style="margin-right: 20px"
                        @click="submit(1)"
                        v-preventReClick="5000"
                    >
                        存草稿箱
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        @click="submit(0)"
                        v-preventReClick="5000"
                    >
                        发布
                    </el-button>
                </div>
            </div>
        </div>
        <!-- 编辑封面 -->
        <!-- <cover-dialog ref="coverdialog" @submitCoverDialog="submitCoverDialog"></cover-dialog> -->
    </div>
</template>

<script>
import wangEditorCustom from './components/wang-editor-custom.vue';
import getOssMixin from '@/mixins/getOssMixin';
import Upload from '@/components/upload-new';
import ossState from '@/utils/ossClient.js';
import {
    addArticleImage,
    getDesignerList,
    getDesignerListOnly,
    getInfo,
} from '@/api/mkt/article-image.js';
import { getCookie } from '@/utils/util.js';
import coverDialog from '../article/cover-dialog';
export default {
    name: '',
    mixins: [getOssMixin],
    components: { Upload, coverDialog, wangEditorCustom },
    data() {
        return {
            result: {
                articleId: null,
                title: '',
                content: '',
                authorId: '',
                reviewer: [],
                files: '',
            },
            files: [],
            columns: {
                authorId: {
                    name: '选择发布人',
                    type: 'select',
                    options: {
                        placeholder: '请选择',
                        options: [
                            // {
                            //     id: '1',
                            //     name: 'aaa',
                            // },
                        ],
                        props: {
                            value: 'userId',
                            label: 'createUserName',
                        },
                        filterable: true,
                    },
                },
                reviewer: {
                    name: '选择编审人',
                    type: 'cascader',
                    options: {
                        placeholder: '请选择',
                        allLevels: false,
                        clearable: true,
                        collapseTags: false,
                        filterable: true,
                        options: [],
                        props: {
                            label: 'createUserName',
                            value: 'userId',
                            checkStrictly: false,
                            emitPath: false,
                            multiple: true,
                        },
                    },
                },
                // title: {
                //     name: '插入案例',
                //     type: 'input',
                //     hidden: false,
                //     options: {
                //         placeholder: '',
                //         disabled: true,
                //     },
                //     rules: [{ required: true, message: '内容名称不能为空' }],
                // },
                files: {
                    name: '封面',
                    type: 'text',
                },
            },
        };
    },
    mounted() {
        ossState.getOssClient();
        this.init();
        let content =
            '<h1 style="text-align: center;"><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">上海社保基数又涨了？</span></h1><h2 style="text-align: center;"><span style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255);">落户政策取消了？</span></h2><h3 style="text-align: right;"><span style="color: rgb(0, 0, 0); background-color: rgb(145, 213, 255);">揭开社保谣言背后的利益链条</span></h3><p><br></p><p><br></p><div data-w-e-type="video" data-w-e-is-void>\n<video poster="" controls="true" width="auto" height="auto"><source src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696659064747..mp4" type="video/mp4"/></video>\n</div><ol><li><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">“上海落户今天起放宽了”“上海落户政策取消了”“普通人也能随便落户”“上海社保基数上涨10%”……在部分社交媒体上，时常会出现类似与社保、落户等政策相关的信息，引发关注。有人质疑，官方似乎并未发布相关消息，网上层出不穷的帖子依据何在？发布者是在分析解读还是造谣引流？</span></li><li><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">上海辟谣平台调查发现，大量贴文都由所谓的咨询服务机构发布，内容有虚有实、真假混杂，目的是向有需求的网民推销落户、社保、公积金等规划、代办业务。这些业务看似诱人，实际暗藏风险。</span></li></ol><p><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169635926671..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169635926671..png" style="width: 366.00px;height: 454.44px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359347499..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359347499..png" style="width: 333.00px;height: 210.19px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359442695..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359442695..png" style="width: 416.00px;height: 520.00px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169635951716..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169635951716..png" style="width: 403.00px;height: 537.33px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359602560..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696359602560..png" style="width: 405.00px;height: 506.25px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362590926..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362590926..png" style="width: 408.00px;height: 611.13px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696381539642..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696381539642..png" style=""/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362666593..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362666593..png" style="width: 459.00px;height: 344.25px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362748014..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696362748014..png" style="width: 456.00px;height: 322.02px;"/></p><h3 style="text-align: right;"><span style="background-color: rgb(135, 232, 222);"><strong>发布不实信息实为引流牟利</strong></span></h3><ul><li style="text-align: justify;">记者向权威部门工作人员求证得知，“上海落户政策取消”“上海社保基数上涨10%”的消息均不属实。上海从未发布过“落户政策取消”的消息，每年的社保基数调整也是从7月1日开始，今年的调整方案尚未公布。</li><li style="text-align: justify;"><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">再看这些帖子的具体内容，不难发现，大多都是对上海当前各类落户政策的整理、集纳。比如一条标题为“上海落户取消”的帖子，内文实际上是居转户、人才引进、留学生、应届生落户、纳税百万落户等具体落户方式的政策细节，并提示网友私聊“免费咨询”。发布者的用户名、简介中也都带有“上海落户”“居转户”“人才引进”等关键词。</span></li><li style="text-align: justify;"><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">记者与其中几个账号进行了沟通，对方都表示自己是提供落户咨询、规划、代办等业务的机构，询问了记者的基本情况，包括学历学位、社保缴纳年限、历年社保缴纳基数、居住证年限、职称等情况，继而提供了相应建议。</span></li><li style="text-align: justify;"><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">比如，一名“积分落户老师”得知记者近3年已达到“1.3倍社保”标准，即缴纳社保的基数已达到上一年度社会平均工资的1.3倍，便推荐记者考一个中级经济师，年底考证，明年初就能落户。另一个账号则建议记者选择人才引进落户，“本科+高新技术企业+2年2倍社保”，即“挂靠”到符合条件的高新技术企业。</span></li></ul><h3 style="text-align: right;"><span style="background-color: rgb(135, 232, 222);"><strong>“创造条件”规划快速落户</strong></span></h3><p><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169636729568..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169636729568..png" style="width: 538.00px;height: 379.16px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696367385716..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696367385716..png" style="width: 500.00px;height: 612.48px;"/><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696367794530..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696367794530..png" style="width: 511.00px;height: 319.78px;"/></p><ol><li style="text-align: left;"><strong>“我也经常收到这些推送，还看过他们的直播。”上海某区人才服务中心的“老法师”老陈告诉记者，那些账号发布的政策有一部分是真实的，但不准确，“这些发布者对不同的政策文件做了整合，叠加在一起，目的是吸引你咨询，做落户的‘规划设计’。”</strong></li><li style="text-align: left;"><strong>通常，用户咨询后会有两种结果：一种是咨询者原本就符合或接近条件，只需要对照要求，补足相应材料即可，比如考出相应的证书；另一种就是咨询者达不到条件，需要“创造条件”，这对希望快速落户上海的咨询者而言，无疑极具吸引力，但也意味着风险和陷阱。</strong></li><li style="text-align: left;"><strong>“创造条件”的具体办法之一，是由中介机构为咨询者找一家符合条件的企业“挂靠”。这样的企业一般是经过认定的高新技术企业，有为员工办理落户的名额。中介机构往往与企业的人事人员等联系，在收取客户报酬后，通过企业内部人员为客户办理“挂靠”，由该公司为客户按照符合落户条件的标准发放薪水、缴纳社保等，且不需要客户真实地为该公司工作。这相当于虚构了客户与该公司的劳动关系，从而获取该公司的人才引进落户名额。</strong></li><li style="text-align: left;"><strong>实际上，相关部门已经注意到了类似现象的存在，会通过仔细核实来杜绝此类行为，但确实会出现“漏网之鱼”。</strong></li><li style="text-align: left;"><strong>“从缴纳社保、发放薪酬等材料层面来看，他们确实是建立了劳动关系，只是申请人并没有实际到岗。要核查只能调取公司的考勤记录，但在实际操作中可能不现实。”老陈介绍，在办理落户业务的申请时，工作人员会核查申请人的教育背景与当前岗位的相关性，“你大学学的是新闻，但申报的岗位是数据工程师，这个明显就不对，会进一步核实。”</strong></li></ol><h3 style="text-align: right;"><span style="background-color: rgb(135, 232, 222);">钻空子走捷径风险重重</span></h3><p>从程序上看，“挂靠”企业快速落户，似乎天衣无缝、各取所需，就连受理机构都不能准确辨别，但真的毫无风险吗？</p><p><br></p><div data-w-e-type="video" data-w-e-is-void>\n<video poster="" controls="true" width="auto" height="auto"><source src="https://sczs.voglassdc.com/app-scj/test/market/20240529/171696374017338..MOV" type="video/mp4"/></video>\n</div><p><span style="background-color: rgb(255, 173, 210);">显然不是。“最简单的，如果这个企业‘没了’，你的投入是不是就白费了？”一位知情人士向记者分析道，能够进行类似操作的企业，往往不是规模较大的成熟企业。成熟企业的人力资源管理比较完善，“钻空子”的可能性小。操作可行性较高的中小企业，则难保能够经受行业和市场的大浪淘沙长期经营下去，或长期保持人才引进的名额。一旦“挂靠”的企业不再具有办理落户的资质，客户可能就将遭受重大损失。</span></p><p><span style="background-color: rgb(211, 173, 247);">一方面是财产损失，除了要向中间人支付一定的好处外，“挂靠”期间企业产生的所有用人成本也都需要客户来承担，包括薪酬和企业缴纳部分的社保、公积金等等，这些费用通常都需要预支给中间人。“这笔钱到底是进了中间人的口袋，还是打到了公司账上？个人账户直接打到公司账上有一定障碍，所以这笔钱的安全性有很大风险。”知情人士说。</span></p><p><img src="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169638413486..png" alt="" data-href="https://sczs.voglassdc.com/app-scj/test/market/20240529/17169638413486..png" style=""/></p><p>另一方面是时间损失。如果“挂靠”中途失败，造成了申请准备流程的中断，甚至是社保缴纳的中断，客户可能需要重新积累年限，对于希望尽快落户的客户而言，无疑浪费了大量时间。</p><p>在中国裁判文书网上，能看到不少因代办落户不成而产生纠纷的案例。至于类似的行为能否得到法律保护，一份判决书中的文件表明了法院观点：“被告协助原告以挂靠在高新技术企业缴纳社保的方式获得上海户口，违反了上海市有关人才落户的相关政策，损害社会公共利益，故服务合同依法应确认无效。”</p><p><s>“这些账号、机构发布的内容，在一定程度上让许多青年人才了解了上海吸引人才的态度。但有些服务则是钻政策空子、走捷径的行为。”老陈提醒，通过类似手段尝试办理落户的结果极不可控，一旦发生意外，不良后果只能由咨询者自己承担。</s></p><p style="text-align: right;"><span style="color: rgb(255, 77, 79);"><strong>【来源：上海网络辟谣】</strong></span></p>';
        let newContent = this.updateVideoPosters(content);
    },
    methods: {
        async init() {
            await this.getDesignerList();
            await this.getDesignerListOnly();
            if (this.$route.query && this.$route.query.id) {
                console.log('--------row', this.$route.query.id);
                await this.showInfo({ id: this.$route.query.id });
            }
        },
        // isDraft 0发布;1草稿；
        submit(isDraft) {
            let that = this;
            let newfiles = this.$refs.uploadbox.imgList || [];
            if (!this.result.authorId && isDraft == 0) {
                this.$message.warning('请选择发布人');
                return false;
            }
            if (!newfiles.length && isDraft == 0) {
                this.$message.warning('上传封面不能为空');
                return false;
            }
            this.result.title = (this.result.title && this.result.title.trim()) || '';
            if (isDraft == 1 && !this.result.authorId && !newfiles.length && !this.result.title) {
                this.$message.warning('保存失败，请填写内容');
                return false;
            }
            let editorContent = this.$refs.customEditer.editor.getHtml();
            editorContent = this.updateVideoPosters(editorContent);
            console.log('----------editorContent', editorContent);
            // return;
            let files = this.getFiles(newfiles);
            let params = {
                articleId: this.result.articleId || null,
                articleType: 2,
                isDraft: isDraft,
                authorId: this.result.authorId || '',
                reviewer: this.result.reviewer || [],
                content: editorContent || '',
                files: files,
                title: this.result.title,
            };
            console.log('-----params', params);
            // return;
            addArticleImage(params).then(res => {
                if (res.errorCode == 200) {
                    let message = isDraft == 0 ? '添加成功' : '保存成功';
                    this.$message.success(message);
                    this.close(isDraft);
                } else {
                    this.$message.info(res.message);
                }
            });
        },
        updateVideoPosters(editorContent) {
            // 方法一
            // 创建一个容器用于解析HTML内容
            // let container = document.createElement('div');
            // container.innerHTML = editorContent;
            // // 查找所有的video标签
            // let videos = container.querySelectorAll('video');
            // // 遍历所有的video标签
            // videos.forEach(video => {
            //     // 查找video标签内的source标签
            //     let source = video.querySelector('source');
            //     if (source) {
            //         // 将source标签的src属性值赋给video标签的poster属性值
            //         video.setAttribute(
            //             'poster',
            //             source.getAttribute('src') +
            //                 '?x-oss-process=video/snapshot,t_1000,f_jpg,w_750,ar_auto'
            //         );
            //     }
            // });
            // // 获取更新后的HTML内容
            // editorContent = container.innerHTML;
            // // 输出更新后的HTML内容
            // console.log(editorContent);
            // return editorContent;

            // 方法二
            // 定义正则表达式模式
            let pattern = /(<video[^>]*poster=")([^"]*)("[^>]*>\s*<source\s+src=")([^"]*)("[^>]*><\/video>)/g;
            // 使用replace方法和正则表达式替换poster属性值
            let updatedHtmlContent = editorContent.replace(pattern, (match, p1, p2, p3, p4, p5) => {
                return `${p1}${p4}?x-oss-process=video/snapshot,t_1000,f_jpg,w_750,ar_auto${p3}${p4}${p5}`;
            });
            console.log(updatedHtmlContent);
            return updatedHtmlContent;
        },
        // 更新图片
        uploadImgList(list, item) {},
        //
        getValue(value) {
            this.result.content = value;
        },
        getFiles(newfiles) {
            let files = [];
            newfiles.map((item, index) => {
                files.push({
                    fileType: 1, //1图片 2视频 3ppt 4pdf 5 视频封面
                    height: item.height || '',
                    orderSort: index,
                    smallUrl: item.smallUrl || '',
                    url: item.url || '',
                    width: item.width || '',
                });
            });
            return files;
        },
        changeFn(val) {},
        clickFn(val) {},
        goBack(isDraft) {
            let path = '/mkt/cm/article-img';
            if (isDraft == 1) {
                //回退到草稿
                path = '/mkt/cm/article-img?isDraft=true';
            } else {
                if (this.$route.query?.isDraft) {
                    path = '/mkt/cm/article-img?isDraft=true';
                }
            }
            this.$router.push({
                path,
            });
        },
        async getDesignerList() {
            let res = await getDesignerList();
            if (res?.isSuccess) {
                res.data.map(item => {
                    item.createUserName =
                        item.createUserName + '（ ' + item.createUserAccount + ' ）';
                });
                this.columns.authorId.options.options = res.data;
            }
        },
        async getDesignerListOnly() {
            let res = await getDesignerListOnly();
            if (res?.isSuccess) {
                res.data.map(item => {
                    item.createUserName =
                        item.createUserName + '（ ' + item.createUserAccount + ' ）';
                });
                this.columns.reviewer.options.options = res.data;
            }
        },
        close(isDraft) {
            this.files = [];
            this.result = {
                title: '',
                content: '',
                authorId: '',
                reviewer: [],
                files: '',
            };
            // this.$refs.uploadbox.imgList = [];
            this.$forceUpdate();
            let path = '/mkt/cm/article-img';
            if (isDraft == 1) {
                path = '/mkt/cm/article-img?isDraft=true';
            }
            this.$router.push({
                path,
            });
        },
        async showInfo(row) {
            let res = await getInfo({ articleId: row.id });
            if (res) {
                this.result = {
                    ...res.data,
                    authorId: res.data.accountId,
                    specialSubjectDetVos: res.data.noteType + '',
                };
                let account = getCookie('account');
                // if (res.data.account == account) {
                //     this.result.authorId = '';
                // }
                let result = res.data;
                let files = result.files;
                if (result.files) {
                    if (result.files.filter(d => d.fileType == 5).length) {
                        console.log('-------111', result.files);
                    }
                    console.log('-------files', files);
                    this.$refs.uploadbox.setList(files);
                }
            }
        },
    },
};
</script>
<style lang="less" scoped>
.mkt {
    padding: 20px 30px;
}
.top-box {
    .input-box {
        padding: 10px 150px;
        width: 800px;
        border-radius: 10rpx;
    }
}
.editor-wrap {
    width: 800px;
    .tooltip {
        font-size: 12px;
        color: #999;
        line-height: 1em;
        margin-bottom: -6px;
        padding: 0 44px;
    }
}
.content {
    display: flex;
}
.form-box {
    width: 30%;
    max-width: 400px;
    padding-left: 50px;
}
</style>
